import { useEffect, useState } from "react";

export function useApplePayAvailability(): boolean | undefined {
  // https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_js_api/checking_for_apple_pay_availability

  const [isApplePayAvailableOnThisDevice, setApplePayAvailableOnThisDevice] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    if (window.ApplePaySession) {
      setApplePayAvailableOnThisDevice(true);
    } else {
      setApplePayAvailableOnThisDevice(false);
    }
  }, []);

  return isApplePayAvailableOnThisDevice;
}
